import { render, staticRenderFns } from "./GonderilecekEvrakList.vue?vue&type=template&id=170bad8b"
import script from "./GonderilecekEvrakList.vue?vue&type=script&lang=ts"
export * from "./GonderilecekEvrakList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports